import { render, staticRenderFns } from "./copycur.vue?vue&type=template&id=5d6ffa22&scoped=true"
import script from "./copycur.vue?vue&type=script&lang=js"
export * from "./copycur.vue?vue&type=script&lang=js"
import style0 from "./copycur.vue?vue&type=style&index=0&id=5d6ffa22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ffa22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6ffa22')) {
      api.createRecord('5d6ffa22', component.options)
    } else {
      api.reload('5d6ffa22', component.options)
    }
    module.hot.accept("./copycur.vue?vue&type=template&id=5d6ffa22&scoped=true", function () {
      api.rerender('5d6ffa22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/copycur.vue"
export default component.exports